'use strict'

/**
 *
 * @name: nnBaseNotify
 *
 */

import DirectiveTemplate from './nn-base-notify.directive.html'
import './nn-base-notify.directive.scss'
import _get from 'lodash.get'

function NnBaseNotifyDirective () {

  'ngInject'

  return {
    restrict: 'E',
    replace: true,
    scope: {
      path: '=*',
      notifications: '=*',
      status: '=*'
    },
    template: DirectiveTemplate,
    controller: DirectiveController
  }
}

function DirectiveController ($scope) {

  'ngInject'

  /*
   *
   * @CONFIG
   *
   */

   $scope.get = _get


  /*
   *
   * @PUBLIC
   *
   */


  /*
   *
   * @PRIVATE
   *
   */



  /*
   *
   * @INIT
   *
   */
}

export default NnBaseNotifyDirective



// WEBPACK FOOTER //
// ./app/components/nn-base-components/nn-base-notify/nn-base-notify.directive.js